import { createConsumer } from "@rails/actioncable"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["readyCount"]
  static values = { batchId: String, itemUrlTemplate: String }

  connect() {
    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "UploadBatchChannel", batch_id: this.batchIdValue },
      { received: (message) => this.itemUpdated(message) }
    )
  }

  disconnect() {
    this.subscription?.unsubscribe()
    this.consumer?.disconnect()
  }

  async itemUpdated(message) {
    if (message.type !== "upload_item_updated") return

    this.updateReadyCount(message.ready_count)

    const item = this.element.querySelector(`#upload-item-${message.item_id}`)
    if (!item) return

    const response = await fetch(this.itemUrlTemplateValue.replace("__ITEM_ID__", message.item_id), {
      credentials: "same-origin",
      headers: { Accept: "text/html" }
    })

    if (response.ok) item.outerHTML = await response.text()
  }

  updateReadyCount(count) {
    this.readyCountTargets.forEach((target) => {
      target.textContent = `${count} file${count === 1 ? "" : "s"} currently ready to publish.`
    })
  }
}
